import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  NgZone,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  signal,
  ViewChild,
} from '@angular/core';
import KeenSlider, {KeenSliderInstance} from 'keen-slider';
import {ImageWithCaption} from '../../../types/ImageWithCaption';
import {isPlatformBrowser} from '@angular/common';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ImagesCarouselData} from '../../../types/ImagesCarouselData';

@Component({
  selector: 'app-images-carousel',
  templateUrl: './images-carousel.component.html',
  styleUrls: ['./images-carousel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImagesCarouselComponent implements OnInit, AfterViewInit, OnDestroy {
  public images = signal<ImageWithCaption[]>([]);
  @ViewChild('sliderRef') sliderRef: ElementRef<HTMLElement>;

  public slider: KeenSliderInstance = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ImagesCarouselData,
    @Inject(PLATFORM_ID) private platformId: any,
    private ngZone: NgZone,
    private _change: ChangeDetectorRef,
    private dialogRef: MatDialogRef<ImagesCarouselComponent>,
  ) {}

  public ngOnInit() {
    if (this.data.images && this.data.images.length > 0) {
      this.images.set(this.data.images);
    }
  }

  public ngAfterViewInit() {
    this.delayedSliderInit();
  }

  public ngOnDestroy() {
    this.slider = null;
  }

  public closeDialog(): void {
    this.dialogRef.close();
  }

  private conditionalSliderInit(): void {
    if (isPlatformBrowser(this.platformId) && this.images() && this.images().length > 1) {
      this.initSlider();
      this._change.markForCheck();
    }
  }

  private initSlider(): void {
    this.slider = new KeenSlider(
      this.sliderRef.nativeElement,
      {
        loop: true,
      },
      [
        (slider) => {
          let timeout;
          let mouseOver = false;

          function clearNextTimeout() {
            clearTimeout(timeout);
          }

          function nextTimeout() {
            clearTimeout(timeout);
            if (mouseOver) return;
            timeout = setTimeout(() => {
              slider.next();
            }, 5000);
          }

          slider.on('created', () => {
            slider.container.addEventListener('mouseover', () => {
              mouseOver = true;
              clearNextTimeout();
            });
            slider.container.addEventListener('mouseout', () => {
              mouseOver = false;
              nextTimeout();
            });
            nextTimeout();
          });
          slider.on('dragStarted', clearNextTimeout);
          slider.on('animationEnded', nextTimeout);
          slider.on('updated', nextTimeout);
        },
      ],
    );
  }

  private delayedSliderInit() {
    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        this.ngZone.run(() => {
          this.conditionalSliderInit();
        });
      }, 0);
    });
  }
}
